const PRE = 'PERFIL_ADMIN';
export const LISTAR = PRE + 'LISTAR';




// WEBPACK FOOTER //
// ./src/routes/admin/ConsultaPerfisAdmin/actionTypes.js